import { Component, Input } from '@angular/core';
import { Order, OrderItem } from '@queries/generated';

@Component({
  selector: 'vnm-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.scss']
})
export class OrderReceiptComponent {
  @Input() order: Order;

  promoCodeUseOn(orderItem: OrderItem) {
    return this.order.promoCodeUses.find((promoCodeUse) => {
      return promoCodeUse.orderItem.id === orderItem.id;
    });
  }

  get billingAddressIsComplete(): boolean {
    return !!this.order.billingAddress.address1;
  }

  get hasAnyShippingInformation(): boolean {
    return !!this.order.shippingAddress || !!this.order.shippingInformation;
  }
}
